import { useEditorDispatchContext } from '/src/features/editor/contexts/EditorContext';
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";

function BlockContainerAction() {

    const dispatch = useEditorDispatchContext();

    const toast = useToastDispatchContext();
    return {
        addSelectedBlock : (block) => dispatch({ type : 'addSelectedBlock', payload : { block }}),
        deleteSelectedBlock : (id) => dispatch({ type : 'deleteSelectedBlock', payload : { id }}),
        setSelectedBlocks : (blocks) => dispatch({ type : 'setSelectedBlocks', payload : { blocks }}),
        deleteAllSelectedBlock : () => dispatch({ type : 'deleteAllSelectedBlock'}),
        updateMouse : (x, y) => dispatch({ type : 'updateMouse', payload : { x, y}}),
        updateMouseAndBlockClicked : (x, y, id) => dispatch({ type : 'updateMouseAndBlockClicked', payload : { x, y, id}}),
        createTmpPath : (x, y, parent_block_id, child_block_id) => dispatch({ type : 'createTmpPath', payload : {x, y, parent_block_id, child_block_id}}),
        resetTmpPath : () => {
            document.getElementById('path_tmp').setAttributeNS(null, 'd', "")
            dispatch({ type : 'resetTmpPath', payload : {}})
        },
        setMagnetPosition : (x, y, id) => dispatch({ type : 'setMagnetPosition', payload : {x, y, id}}),
        resetMagnetPosition : () => dispatch({ type : 'resetMagnetPosition'}),
    }
}

export default BlockContainerAction;